<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
